export var props = {
  getSpan: {
    type: Function,
    // [rowspan,colspan]
    default: () => [1, 1]
  },
  columns: {
    type: [Object, Array],
    required: true
  },
  data: {
    type: Array,
    required: true
  },
  pk: {
    type: String,
    default: 'id'
  },
  showIndex: {
    type: [Boolean, Object],
    default: false
  },
  rowStyles: {
    type: String,
    default: ''
  }
};